/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const MenuB2BIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#6190B7',
  colorSecondary = '#C9DCEB',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.25 30.75V35.25H16L11.5 24.405C12.1975 24.135 12.9626 24 13.75 24H20.5C24.2349 24 27.25 27.0149 27.25 30.75Z"
        fill={colorSecondary}
      />
      <path
        d="M16 30.75V35.25H7V30.75C7 27.8025 8.86757 25.305 11.5 24.405C14.1324 25.305 16 27.8025 16 30.75Z"
        fill={colorSecondary}
      />
      <path d="M16 24H18V33H16V24Z" fill={color} />
      <path
        d="M32.25 9.5C32.25 12.1056 31.1914 14.4942 29.4542 16.2042C27.7444 17.9414 25.3558 19 22.75 19C22.2343 19 21.7186 18.9456 21.23 18.8643L14.1999 13.5986C13.5757 12.35 13.25 10.9656 13.25 9.5C13.25 6.8942 14.3086 4.50563 16.0458 2.79563C17.7556 1.05857 20.1442 0 22.75 0C25.3558 0 27.7444 1.05857 29.4542 2.79563C31.1914 4.50563 32.25 6.8942 32.25 9.5Z"
        fill={colorSecondary}
      />
      <path
        d="M22.75 17.75C22.75 20.855 20.23 23.375 17.125 23.375C14.02 23.375 11.5 20.855 11.5 17.75C11.5 14.7574 13.8399 12.3049 16.7874 12.1475L22.615 16.5125C22.7049 16.9175 22.75 17.3225 22.75 17.75Z"
        fill={color}
      />
      <path
        d="M26.8002 7.1751V9.8751H24.1002V12.5751H21.4002V9.8751H18.7002V7.1751H21.4002V4.4751H24.1002V7.1751H26.8002Z"
        fill={color}
      />
      <path
        d="M22.6147 16.5125C20.0271 16.1074 17.8672 14.4424 16.7871 12.1475C16.8997 12.125 17.0122 12.125 17.1247 12.125C19.8022 12.125 22.0522 13.9924 22.6147 16.5125Z"
        fill={color}
      />
    </svg>
  );
};
